import banner1 from "../assets/images/banner/jslc1.png";
import banner2 from "../assets/images/banner/jslc2.png";
import banner3 from "../assets/images/banner/jslc3.png";
export default [
  { src: banner1 },
  { src: banner2 },
  { src: banner3 },
];
